module.exports = __webpack_public_path__ + "static/img/no-notifications-bell.170482c4.png";